'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _ariaPopinUtils = require('./ariaPopinUtils');

var _ariaPopinUtils2 = _interopRequireDefault(_ariaPopinUtils);

var _ButtonTooltip = require('../ButtonTooltip/ButtonTooltip');

var _ButtonTooltip2 = _interopRequireDefault(_ButtonTooltip);

require('./Popin.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popin = function (_Component) {
  (0, _inherits3.default)(Popin, _Component);

  function Popin() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Popin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popin.__proto__ || (0, _getPrototypeOf2.default)(Popin)).call.apply(_ref, [this].concat(args))), _this), _this.focusFirstChild = function () {
      _ariaPopinUtils2.default.Utils.focusFirstDescendant(_this.bodyRef);
    }, _this.focusLastChild = function () {
      _ariaPopinUtils2.default.Utils.focusLastDescendant(_this.bodyRef);
    }, _this.initRef = function (ref) {
      _this.popinRef = ref;
    }, _this.initBodyRef = function (ref) {
      _this.bodyRef = ref;
    }, _this.trapFocus = function (event) {
      if (_this.props.isOpen && !_this.popinRef.contains(event.target)) {
        _this.focusFirstChild();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Popin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('focus', this.trapFocus, true);
      if (this.props.isOpen) {
        this.focusFirstChild();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        this.focusFirstChild();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('focus', this.trapFocus, true);
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      e.preventDefault();
      this.props.closeCallback();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classname2.default)("Popin", { 'is-open': this.props.isOpen }), ref: this.initRef },
        _react2.default.createElement('div', { className: 'Popin__bg', onClick: this.onClick.bind(this) }),
        this.props.isOpen && _react2.default.createElement('div', { tabIndex: '0', onFocus: this.focusLastChild }),
        _react2.default.createElement(
          'div',
          {
            className: 'Popin__body',
            style: { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, height: this.props.height },
            ref: this.initBodyRef
          },
          _react2.default.createElement(_ButtonTooltip2.default, { className: 'Popin__close icon icon-cross no-text-decoration', onClick: this.onClick.bind(this) }),
          _react2.default.createElement(
            'div',
            { className: 'Popin__content' },
            this.props.children
          )
        ),
        this.props.isOpen && _react2.default.createElement('div', { tabIndex: '0', onFocus: this.focusFirstChild })
      );
    }
  }]);
  return Popin;
}(_react.Component);

Popin.propTypes = {
  isOpen: _propTypes2.default.bool,
  closeCallback: _propTypes2.default.func,
  maxWidth: _propTypes2.default.string,
  maxHeight: _propTypes2.default.string,
  height: _propTypes2.default.string
};

Popin.defaultProps = {
  isOpen: false,
  closeCallback: function closeCallback() {},
  maxWidth: '833px',
  maxHeight: '880px',
  height: null
};

exports.default = Popin;


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/Popin/Popin.js
// module id = 250
// module chunks = 0